import { FavoriteChefStep } from './FavoriteChefStep'
import { CalendarStep } from './CalendarStep'
import { DownloadAppStep } from './DownloadAppStep'
import { RateMealsStep } from './RateMealsStep'
import { FirstOrderStep } from './FirstOrderStep'

export const STEP_COMPONENTS = {
  eater_profile: FavoriteChefStep,
  calendar: CalendarStep,
  mobile_app: DownloadAppStep,
  rate_meals: RateMealsStep,
  trial_order: FirstOrderStep
} as const

export type StepKey = keyof typeof STEP_COMPONENTS
